export default "/2.png"